import { bomItemAllActivitiesSelector } from './allBomItemActivitiesSelector'
import { bomItemActivityByArticleIdSelector } from './bomItemActivityByArticleIdSelector'
import { bomItemActivityByIdSelector } from './bomItemActivityByIdSelector'
import { bomItemActivityByWorkingStepSelector } from './bomItemActivityByWorkingStepSelector'
import { bomItemActivityByWorkingStepPositionSelector } from './bomItemActivityByWorkingStepPositionSelector'
import { bomItemArticlePerWorkingStepSelector } from './bomItemArticlesPerWorkingStepSelector'
import { bomItemKeywordsPerWorkingStepSelector } from './bomItemKeywordsPerWorkingStepSelector'
import { bomItemRawMaterialActivitySelector } from './bomItemRawMaterialActivitySelector'

export const bomItemActivitiesSelectors = {
  allActivities: bomItemAllActivitiesSelector,
  byArticleId: bomItemActivityByArticleIdSelector,
  byWorkingStep: bomItemActivityByWorkingStepSelector,
  byWorkingStepPosition: bomItemActivityByWorkingStepPositionSelector,
  byActivityId: bomItemActivityByIdSelector,
  articlesPerWorkingStep: bomItemArticlePerWorkingStepSelector,
  keywordsPerWorkingStep: bomItemKeywordsPerWorkingStepSelector,
  rawMaterialActivity: bomItemRawMaterialActivitySelector,
}
